import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { UserExidRequestBody, UserExidResponse } from "./types";

export class UserExidAPI extends BaseAPI<
  UserExidRequestBody,
  UserExidResponse
> {
  protected route = ApiRoutes.auth.exid;
  protected method = RequestMethod.POST;
}
